// react-router v6: a layout is a plain wrapper that gets rendered as a <Route element>, so
// it must not render a <Route> itself — v6's <Route> throws unconditionally when it appears
// anywhere other than as a direct child of <Routes>, and v5's `render` prop is gone. This
// one was missed when the other layouts (see ../empty) were migrated, which crashed the only
// route using it, /image-viewer.
const NoLayout = ({ component: Component, ...rest }) => <Component {...rest} />;

export default NoLayout;
